import { useCallback } from 'react';

import Translate from '@components/Translate';
import { To, useNavigate } from '@router';
import * as Sentry from '@sentry/react'; // Import Sentry
// UIKit Components
import { Button, FlexBox, FlexBoxProps, Typography } from '@spazious/react-components';

export type ErrorBoxProps = FlexBoxProps & {
  error:
    | {
        statusText: string;
      }
    | {
        message: string;
      };
  link?: To;
};

/**
 * Box for representing errors
 */
export const ErrorBox: React.FC<ErrorBoxProps> = ({ error, link = -1 }) => {
  const navigate = useNavigate();

  const handleGoBack = useCallback(() => {
    navigate(link);
  }, [link, navigate]);

  if (error) {
    Sentry.captureException(error);
  }

  return (
    <FlexBox alignItems="center" height="100%" justifyContent="center">
      <FlexBox gap={2}>
        <Typography variant="h4">
          <Translate>Oops!</Translate>
        </Typography>
        <Typography paragraph>
          <Translate>Sorry, an unexpected error has occurred.</Translate>
        </Typography>
        <Typography variant="caption">{error?.statusText ?? error?.message}</Typography>
        <Button onClick={handleGoBack}>
          <Translate>
            {typeof link === 'number' && link < 0 ? 'Go back' : 'Go to safety zone'}
          </Translate>
        </Button>
      </FlexBox>
    </FlexBox>
  );
};

export default ErrorBox;
